export default __webpack_public_path__ + "static/media/alisha1.e7226d3e.jpg";